import React, { createContext, useEffect, useState } from "react";

export const ChatWsContext = createContext(null)

export default function ChatWsContextProvider(props) {

    const BASE_URL =
		!process.env.NODE_ENV || process.env.NODE_ENV === "production"
			? window._env_.REACT_APP_BASE_ENDPOINT
			: process.env.REACT_APP_BASE_ENDPOINT;

    let userDataTxt = localStorage.getItem("userData")
    let userData = JSON.parse(userDataTxt)
    let uuid;
    uuid = userData !== null ? userData.uuid : ""
    
    let token = localStorage.getItem("token")
    let wsPath = BASE_URL.replace("https", "wss")+"/ws"

    // ################################################################################################
    // STATE
    // ################################################################################################

    const [activeRoom, setActiveRoom]                           = useState(null);
    const [detailActiveRoom, setDetailActiveRoom]               = useState(null);
    const [memberRoom, setMemberRoom]                           = useState(null)
    const [selectedMessage, setSelectedMessage]                 = useState(null)
    const [forwardMessage, setForwardMessage]                   = useState(null)
    const [sendForwardMessage, setSendForwardMessage]           = useState(null)
    const [memberGroup, setMemberGroup]                         = useState(null)
    const [roomByUUID, setRoomByUUID]                           = useState([])
    const [roomArchiveByUUID, setRoomArchiveByUUID]             = useState([])
    const [messageByRoom, setMessageByRoom]                     = useState([])
    const [chatSocket, setChatSocket]                           = useState(null);

    // ################################################################################################
    // WEBSOCKET
    // ################################################################################################

    // OPEN CONNECTION
    const connectSocket = (roomID) => {
        let id = roomID ? roomID : uuid
        const websocket = new WebSocket(`${wsPath}/${id}/chat`);
        setChatSocket(websocket);
    }

    useEffect(() => {
        connectSocket()
    }, [])

    // WEBSOCKET LISTENER
    if (chatSocket !== null) {
        chatSocket.onopen = () => {
        }

        chatSocket.onmessage = (event) => {
            let res = JSON.parse(event.data);
            if (res.type === "chat-room-create") {
                roomByUUID.push(res.data)
                setRoomByUUID([...roomByUUID])
            } else if (res.type === "chat-message-create") {
                if (activeRoom !== null) {
                    if (activeRoom.id === res.data.room_id) {
                        messageByRoom.push(res.data)
                        setMessageByRoom([...messageByRoom])
                    }
                }
            } else if (res.type === "chat-message-revoke-for-all") {
                let newList = messageByRoom.filter(item => item.id !== res.data.id)
                setMessageByRoom(newList)
            } else if (res.type === "chat-room-visible") {
                let newList = roomByUUID.filter(item => item.id !== res.data.id)
                setRoomByUUID(newList)
                let newListArchive = roomArchiveByUUID.filter(item => item.id !== res.data.id)
                setRoomArchiveByUUID(newListArchive)
            } else if (res.type === "chat-room-archive") {
                let newList = roomByUUID.filter(item => item.id !== res.data.id)
                setRoomByUUID([...newList])
            } else if (res.type === "chat-room-un-archive") {
                let newList = roomArchiveByUUID.filter(item => item.id !== res.data.id)
                setRoomArchiveByUUID([...newList])
            }
        }
    }

    // CREATE ROOM
    const createRoomChat = (typeRoom, nameRoom, memberRoom) => {
        let body = {
            type: "chat-room-create",
            is_secure: true,
            token: token,
            payload: {
                type: typeRoom,
                name: nameRoom,
                member_id: memberRoom
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // CREATE NEW MESSAGE
    const createNewMessage = (type, message, parentID, attachmentID) => {
        if(type == "text"){
            let body = {
                type: "chat-message-create",
                is_secure: true,
                token: token,
                payload: {
                    room_id: activeRoom.id,
                    content_type: type,
                    parent_id: parentID,
                    content: message,
                    attachment_id: attachmentID,
                }
            }
            chatSocket.send(JSON.stringify(body));
        }else if(type == "forward"){
            let body = {
                type: "chat-message-create",
                is_secure: true,
                token: token,
                payload: {
                    room_id: activeRoom.id,
                    content_type: type,
                    id: message,
                    attachment_id: attachmentID,
                }
            }
            chatSocket.send(JSON.stringify(body));
        }
    }

    // READ MESSAGE
    const readMessage = (idRoom) => {
        let body = {
            type: "chat-message-read",
            is_secure: true,
            token: token,
            payload: {
                id: idRoom
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // REVOKE MESSAGE SELF
    const revokeMessageSelf = (idMessage) => {
        let newList = messageByRoom.filter(item => item.id !== idMessage)
        setMessageByRoom(newList)
        let body = {
            type: "chat-message-revoke-for-me",
            is_secure: true,
            token: token,
            payload: {
                id: idMessage
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // REVOKE MESSAGE ALL
    const revokeMessageAll = (idMessage) => {
        let body = {
            type: "chat-message-revoke-for-all",
            is_secure: true,
            token: token,
            payload: {
                id: idMessage
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // END CONVERSATION
    const endConversation = (idRoom) => {
        let body = {
            type: "chat-room-visible",
            is_secure: true,
            token: token,
            payload: {
                id: idRoom
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // ARCHIVE CONVERSATION
    const archiveConversation = (idRoom) => {
        let body = {
            type: "chat-room-archive",
            is_secure: true,
            token: token,
            payload: {
                id: idRoom
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // UN-ARCHIVE CONVERSATION
    const unArchiveConversation = (idRoom) => {
        let body = {
            type: "chat-room-un-archive",
            is_secure: true,
            token: token,
            payload: {
                id: idRoom
            }
        }
        chatSocket.send(JSON.stringify(body));
    }

    // ################################################################################################
    // OTHER
    // ################################################################################################

    const handleSetListMember = (response) => {
        let meAsAdmin = true
        if (response.data !== null) {
            let newListMember = []
            if (response.data.admins !== null) {
                response.data.member.map((item) => {
                    if (item.uuid === uuid) {
                        let memberData = response.data.admins.filter((itemMember) => itemMember.uuid === uuid)
                        meAsAdmin = memberData[0] !== undefined ? true : false
                        item.isAdmin = meAsAdmin
                        item.meAsAdmin = meAsAdmin
                        item.isMe = true
                        item.idRoom = activeRoom.id
                        newListMember.push(item)
                    } else {
                        let memberData = response.data.admins.filter((itemAdmin) => itemAdmin.uuid === item.uuid)
                        if (memberData[0] === undefined) {
                            item.isAdmin = false
                            item.meAsAdmin = meAsAdmin
                            item.isMe = false
                            item.idRoom = activeRoom.id
                            newListMember.push(item)
                        }
                    }
                })

                response.data.admins.map((item) => {
                    if (item.uuid !== uuid) {
                        item.isAdmin = true
                        item.meAsAdmin = meAsAdmin
                        item.isMe = false
                        item.idRoom = activeRoom.id
                        newListMember.push(item)
                    }
                })
            }
            newListMember.reverse()
            setMemberGroup([...newListMember])
        }
    }

    return (<>
        <ChatWsContext.Provider value={
            {
                uuid,
                activeRoom, setActiveRoom,
                detailActiveRoom, setDetailActiveRoom,
                memberRoom, setMemberRoom,
                selectedMessage, setSelectedMessage,
                forwardMessage, setForwardMessage,
                messageByRoom, setMessageByRoom,
                memberGroup, setMemberGroup, handleSetListMember,
                roomByUUID, setRoomByUUID,
                roomArchiveByUUID, setRoomArchiveByUUID,
                sendForwardMessage, setSendForwardMessage,
                connectSocket,
                createNewMessage,
                createRoomChat,
                readMessage,
                revokeMessageSelf,
                revokeMessageAll,
                endConversation,
                archiveConversation,
                unArchiveConversation
            }
        }>
            {props.children}
        </ChatWsContext.Provider>
    </>)
}
